export default "__VITE_ASSET__CXGy8XeG__"